

<template>
    <div class="bg-white flex justify-between md:flex-row p-3 mb-5 rounded gap-3 md:gap-5 max-md:hidden">
        <router-link :to="{ name: 'publicationLiked' }" class="relative text-base font-medium cursor-pointer text-[#828282]">
            {{ $t('nav.publicationLiked') }}
            <span class="absolute -top-2 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getPublicationLikedCount > 0">{{ getPublicationLikedCount }}</span>
        </router-link>
        <router-link :to="{ name: 'foodLiked' }"
             class="relative text-base font-medium cursor-pointer text-[#828282]">
            {{ $t('nav.foodLiked') }}
            <span class="absolute -top-2 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getFoodLikedCount > 0">{{ getFoodLikedCount }}</span>
        </router-link>
        <router-link :to="{ name: 'mallLiked' }" class="relative text-base font-medium cursor-pointer text-[#828282] ">
            {{ $t('nav.mallLiked') }}
            <span class="absolute -top-2 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getMallLikedCount > 0">{{ getMallLikedCount }}</span>
        </router-link>
        <router-link v-if="HABARLAR_ENABLED" :to="{ name: 'newsLiked' }" class="relative text-base font-medium cursor-pointer text-[#828282] ">
            {{ $t('nav.newsLiked') }}
            <span class="absolute -top-2 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getNewsLikedCount > 0">{{ getNewsLikedCount }}</span>
        </router-link>
        <router-link :to="{ name: 'mediaLiked' }" class="relative text-base font-medium cursor-pointer text-[#828282] ">
            {{ $t('nav.mediaLiked') }}
            <span class="absolute -top-2 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getMediaLikedCount > 0">{{ getMediaLikedCount }}</span>
        </router-link>
        <router-link :to="{ name: 'businessLiked' }" class="relative text-base font-medium cursor-pointer text-[#828282] ">
            {{ $t('nav.businessLiked') }}
            <span class="absolute -top-2 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getBusinessLikedCount > 0">{{ getBusinessLikedCount }}</span>
        </router-link>
    </div>
</template>
<script>
import { mapState } from 'pinia'
import { useAppStore } from '@/store'
import { FEATURE_FLAGS } from '@/constants'
export default {
    name: "LikedNav.vue",
    data() {
        return {
            HABARLAR_ENABLED: FEATURE_FLAGS.HABARLAR,
        }
    },
    computed: {
        ...mapState(useAppStore, ['getPublicationLikedCount', 'getFoodLikedCount', 'getMallLikedCount', 'getNewsLikedCount', 'getMediaLikedCount', 'getBusinessLikedCount']),
    }
}
</script>
<style scoped>
.router-link-exact-active{
    border-bottom: 1px solid #409DBA;
    color: #000000;
}
</style>